/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M26.7 6.7l-1.4-1.4-9.3 9.3-9.3-9.3-1.4 1.4 9.3 9.3-9.3 9.3 1.4 1.4 9.3-9.3 9.3 9.3 1.4-1.4-9.3-9.3z"/>'
  }
})
